import { createSlice } from '@reduxjs/toolkit';

export const homePageOne = createSlice({
  name: 'homePageOne',
  initialState: {
    data: undefined,
  },

  reducers: {
    setHomePageOne: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setHomePageOne } = homePageOne.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getHomePageOne = (state) => {
  return state.homePageOne.data;
};

export default homePageOne.reducer;
